export const CustomerCodeLocationMap = [
  {
    id: 'sav,Maryland,New York,USA',
    display: 'sav,Maryland,New York,USA',
  },
  {
    id: 'lhl,Maryland,New York,USA',
    display: 'lhl,Maryland,New York,USA',
  },
];
